<app-page-heading [heading]="'Pharmacy Management'" [hasBackButton]="false"></app-page-heading>

<mat-tab-group class="tab-container"
               [selectedIndex]="activeTabIndex"
               (selectedTabChange)="onTabSelectionChanged($event)">
    <mat-tab label="National Drugs">
        <ng-template matTabContent>
            <app-national-drugs></app-national-drugs>
        </ng-template>
    </mat-tab>
    <mat-tab label="External Drug Data">
        <ng-template matTabContent>
            <app-external-drug-data></app-external-drug-data>
        </ng-template>
    </mat-tab>
    <mat-tab label="Master Drugs">
        <ng-template matTabContent>
            <app-master-drugs></app-master-drugs>
        </ng-template>
    </mat-tab>
    <mat-tab label="Drug Interactions">
        <ng-template matTabContent>
            <app-drug-interactions></app-drug-interactions>
        </ng-template>
    </mat-tab>
    <mat-tab label="National Drug Formularies">
        <ng-template matTabContent>
            <app-national-drug-formularies></app-national-drug-formularies>
        </ng-template>
    </mat-tab>
    <mat-tab label="Drug Management Plans">
        <app-drug-management-plans></app-drug-management-plans>
    </mat-tab>
    <mat-tab label="Manufacturers">
        <ng-template matTabContent>
            <app-manufacturers></app-manufacturers>
        </ng-template>
    </mat-tab>
    <mat-tab label="Ingredients">
        <ng-template matTabContent>
            <app-ingredients></app-ingredients>
        </ng-template>
    </mat-tab>
    <mat-tab label="ATC Codes">
        <ng-template matTabContent>
            <app-atc-codes></app-atc-codes>
        </ng-template>
    </mat-tab>
</mat-tab-group>
